import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { ProfileProvider } from "@/context/ProfileContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import Profile from "@/pages/Profile";
import Goals from "@/pages/Goals";
import Paychecks from "@/pages/Paychecks";
import Pension from "@/pages/Pension";
import IncomePlan from "@/pages/IncomePlan";
import RetireDate from "@/pages/RetireDate";
import Simulator from "@/pages/Simulator";
import IRA from "@/pages/IRA";
import Funds from "@/pages/Funds";
import ContentHub from "@/pages/ContentHub";
import Article from "@/pages/Article";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Support from "@/pages/Support";
import About from "@/pages/About";
import WhyFree from "@/pages/WhyFree";
import Unsubscribe from "@/pages/Unsubscribe";
import Terms from "@/pages/Terms";
import Checklist from "@/pages/Checklist";
import SharedChecklist from "@/pages/SharedChecklist";
import SharedSnapshot from "@/pages/SharedSnapshot";
import RetirementCheck from "@/pages/RetirementCheck";
import Home from "@/pages/Home";
import EditorialPolicy from "@/pages/EditorialPolicy";
import Contact from "@/pages/Contact";
import AdminReferrals from "@/pages/AdminReferrals";
import AdminScreenshots from "@/pages/AdminScreenshots";
import { CookieBanner } from "@/components/CookieBanner";
import { AdSenseLoader } from "@/components/AdSenseLoader";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProfileProvider><AppShell /></ProfileProvider>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/paychecks" element={<Paychecks />} />
        <Route path="/pension" element={<Pension />} />
        <Route path="/income" element={<IncomePlan />} />
        <Route path="/best-date" element={<RetireDate />} />
        <Route path="/simulator" element={<Simulator />} />
        <Route path="/ira" element={<IRA />} />
        <Route path="/checklist" element={<Checklist />} />
        <Route path="/admin/referrals" element={<AdminReferrals />} />
        <Route path="/admin/screenshots" element={<AdminScreenshots />} />
      </Route>
      <Route element={<ProfileProvider><AppShell publicMode /></ProfileProvider>}>
        <Route path="/funds" element={<Funds />} />
        <Route path="/learn" element={<ContentHub />} />
        <Route path="/learn/:slug" element={<Article />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/about" element={<About />} />
        <Route path="/why-free" element={<WhyFree />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/" element={<Home />} />
        <Route path="/editorial-policy" element={<EditorialPolicy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/check" element={<RetirementCheck />} />
        <Route path="/shared/snapshot/:token" element={<SharedSnapshot />} />
        <Route path="/shared/:token" element={<SharedChecklist />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="tl-theme">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <AdSenseLoader />
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}
